import axios from "axios";

export default class SubscriptionService {

	async getSubscriptions() {
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/subscriptions',
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
				},
			});
			return res.data;
		} catch (err) {
			return err
		}
	}

	async addSubscription(subscription) {
		try {
			const res = await axios({
				method: 'post',
				url: 'dashboard/subscriptions/add',
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
				},
				data: {
					'name_ar': subscription.name_ar,
					'name_en': subscription.name_en,
					'max_contacts': subscription.max_contacts,
					'max_users': subscription.max_users,
					'annual_price': subscription.annual_price,
					'monthly_price': subscription.monthly_price,
					'description_ar': subscription.description_ar,
					'description_en': subscription.description_en,
					'features': subscription.features,

				},
			});
			return res.data;
		} catch (err) {
			console.log(err);
			return err;
		}
	}
	async EditSubscription(subscription) {
		try {
			const res = await axios({
				method: 'put',
				url: 'dashboard/subscriptions/edit',
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
				},
				data: {
					'id': subscription.id,
					'name_ar': subscription.name_ar,
					'name_en': subscription.name_en,
					'max_contacts': subscription.max_contacts,
					'max_users': subscription.max_users,
					'annual_price': subscription.annual_price,
					'monthly_price': subscription.monthly_price,
					'description_ar': subscription.description_ar,
					'description_en': subscription.description_en,
					'features': subscription.features,
				}
			});
			return res.data;
		} catch (err) {
			return err;
		}
	}
	async removeSubscription(subId) {
		try {
			const res = await axios({
				method: 'delete',
				url: 'dashboard/subscription/' + subId,
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
				},
			});
			return res;
		} catch (err) {
			return err
		}
	}
}
